import { CIRCLE_TILE_WIDTH_PIXELS } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Tile/sharedStylingConsts";
import { IGridComponent } from "@faire/web-api--source/indigofair/data/IGridComponent";
import { IImageTile } from "@faire/web-api--source/indigofair/data/IImageTile";

export const getMaxNumRows = (
  truncationBehaviour: IGridComponent.ITruncationBehaviour | undefined,
  isExpanded: boolean
) => {
  if (
    (isExpanded && truncationBehaviour?.expand) ||
    truncationBehaviour?.none
  ) {
    // show all rows
    return `repeat(auto-fill, minmax(0px, 1fr))`;
  }
  const definedMaxRows =
    truncationBehaviour?.clip?.max_rows ??
    truncationBehaviour?.expand?.collapsed_max_rows;
  if (definedMaxRows) {
    // show a certain number of rows until expanded (if allowed)
    return `repeat(${definedMaxRows}, 1fr)`;
  }

  return undefined;
};

export const getAutoRows = (
  truncationBehaviour: IGridComponent.ITruncationBehaviour | undefined,
  isExpanded: boolean
) => {
  if (isExpanded && truncationBehaviour?.expand) {
    return "auto"; // allow number of rows to grow to fit content
  }
  return "0px"; // hide all rows not defined by grid-template-columns
};

export const getColumnWidth = (
  imageTileVariant: keyof typeof IImageTile.ImageTileVariant
) => {
  if (
    imageTileVariant === IImageTile.ImageTileVariant.CIRCLE_TILE ||
    imageTileVariant === IImageTile.ImageTileVariant.SMALL_CIRCLE_TILE
  ) {
    return CIRCLE_TILE_WIDTH_PIXELS;
  }

  return {
    mobileAndAbove: 0,
  };
};
